module.exports = __webpack_public_path__ + "static/media/igloo.d088407b.svg";